import { render, staticRenderFns } from "./RadioViolation.vue?vue&type=template&id=7f39d38a"
import script from "./RadioViolation.vue?vue&type=script&lang=js"
export * from "./RadioViolation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports